import ServiceDetail from '@/components/feature/ServiceDetail';

export default function WebsiteDevelopmentPage() {
  return <ServiceDetail slug="website-development" />;
}